<template>
  <a-card>
    <span slot="title">Daftar Sisa Cuti</span>
    <div slot="extra" class="d-flex flex-row">
      <a-input-search v-model="search" placeholder="Pencarian ... " class="m-right" />
      <a-select
        placeholder="Status"
        v-model="status"
        class="w-full"
        allowClear
        style="margin-right: 15px"
      >
        <a-select-option v-for="item in statusKaryawan" :key="item.key">{{item.value}}</a-select-option>
      </a-select>
    </div>
    <a-table :dataSource="searching" :columns="columns" 
      bordered style="margin-top: 10px;" size="small"
      :loading="loading.table">
      <template slot="sisa_cuti" slot-scope="value, item">
        <div style="display:flex; justify-content: space-between; align-items: center; width: 100%">
          <div style="width: 100%; margin-right: 5px; text-align: right;">{{ item.sisa_cuti }}</div>
          <a-button icon="edit" @click="handleCuti(item)">Edit</a-button>
        </div>
      </template>
    </a-table>
    <a-modal :maskClosable="false" v-model="isEdit">
      <template slot="footer">
        <a-button key="back" @click="handleClose">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleCutiOk">Submit</a-button>
      </template>

      <div slot="title">Perubahan Jatah Cuti Karyawan</div>
      <a-form :form="form">
        <a-form-item class="m-remove" label="Sisa Cuti">
          <a-input read-only v-decorator="['sisa_cuti', {initialValue: selectedValue.sisa_cuti} ]" />
        </a-form-item>
        <a-form-item class="m-remove" label="Penambahan / Pengurangan Cuti">
          <a-input-number
            v-decorator="[
            'rubah_cuti',
            {initialValue: 0,
              rules: [{ required: true, message: 'Penambahan / Pengurangan Cuti Tidak Boleh Kosong' }],
            },
          ]"
            :min="-30"
            :max="30"
          />
        </a-form-item>
        <a-form-item class="m-remove" label="Deskripsi">
          <a-input
            v-decorator="[
            'deskripsi',
            {
              rules: [{ required: true, message: 'Deskripsi Tidak Boleh Kosong' }],
            },
          ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import Axios from "axios";
import { mapGetters } from "vuex";

const columns = [
  {
    dataIndex: 'tlc', 
    title: 'TLC',
    align: "center",
    width: '6%',
  },
  {
    dataIndex: 'nama', 
    title: 'Nama Karyawan',
    width: '39%',
  },
  {
    dataIndex: 'divisi', 
    title: 'Divisi',
    width: '30%',
  },
  {
    dataIndex: 'status', 
    title: 'Status',
    width: '10%',
    align: "center",
  },
  {
    dataIndex: 'sisa_cuti', 
    title: 'Sisa Cuti',
    scopedSlots: { customRender: 'sisa_cuti' },
    width: '15%',
  }
];

export default {
  name: "MonitoringSisaCuti",
  props: ["spesialFor"],
  components: {
  },
  data() {
    return {
      dataSource: [],
      columns,
      loading: {
        table: false,
      },
      search: null,
      status: null,
      statusKaryawan: [
        {"key": "KONTRAK", "value": "Kontrak"},
        {"key": "TETAP", "value": "Tetap"}
      ],
      isEdit: false,
      btnLoading: false,
      selectedValue: {}
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getStatusKaryawan"]),
    searching() {
      let data = this.dataSource;

      if (this.search) {
        data = data.filter(
          item =>
            item.nama && item.nama.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.tlc && item.tlc.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            item.divisi && item.divisi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      if(this.status){
        data = data.filter(
        item =>
          item.status && item.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }
      return data;
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  methods: {
    async fetchData(){
      this.loading.table = true
      try {
        const response = await Axios({
          method: 'GET',
          url: this.$serviceUrl + "master_karyawan/mon_sisa_cuti",
          params: {
            "X-API-KEY": this.getAuth.apikey,
          },
          auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
          },
        })
        if(response) {            
          this.dataSource = response.data.data
        }
        this.loading.table = false        
      } catch (error) {
        this.loading.table = false
        console.log(error);
      }
    },
    handleCuti(record) {
      this.selectedValue = record;
      this.isEdit = true;
    },
    handleClose() {
      this.form.resetFields();
      this.isEdit = false;
    },
    handleCutiOk() {
      this.form.validateFields((err, values) => {
        let post = new FormData();
        this.btnLoading = true;
        post.append("tlc_karyawan", this.selectedValue.tlc);
        post.append("user_update", this.getAuth.username);
        post.append("jumlah_cuti", values.rubah_cuti);
        post.append("deskripsi", values.deskripsi);

        Axios({
          method: "post",
          url: this.$serviceUrl + "master_karyawan/edit_cuti",
          processData: false,
          data: post,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "multipart/form-data",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            this.isEdit = false;
            this.btnLoading = false;
            this.fetchData();
            this.form.resetFields();
          })
          .catch((err) => {
            console.log(err);
            this.isEdit = false;
          });
      });
    },
  },
  mounted() {
    this.fetchData()
  },
  activated() {
  },
};
</script>

<style lang="less">
</style>
